<template>
  <footer data-scroll  class="footer">
    <p>
      <a accesskey="B" href="#bottom" title="bottom" class="accesskey-bottom">:::</a>
      <a 
        v-for="(link, idx) in links"
        :key="idx"
        :href="link.path"
        class="link"
      >
        {{link.title}}
      </a>
    </p>
    <p>Copyright © 2019 Yilan Branch, Forestry and Nature Conservation Agency, Ministry of Agriculture 農業部林業及自然保育署宜蘭分署 版權所有</p>
    <p>電話：03-9545-114</p>
    <p>地址：26548 宜蘭縣羅東鎮中正北路118號</p>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {
        links: [
          {
            title: '網站導覽',
            path: '/sitemap',
          },
          {
            title: '資訊安全政策',
            path: '/security'
          },
          {
            title: '隱私權政策',
            path: '/privacy'
          },
          {
            title: '政府網站資料開放宣言',
            path: '/opendata'
          },
          {
            title: '說明內容與聯絡資訊',
            path: '/contactus'
          },
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

.link  {
  color: white;
  text-decoration: none;
  margin-right: 8px;
}

.link:hover  {
  text-decoration: underline;
}

/deep/.accesskey-bottom{
  color: #2a4c38 !important;
}

</style>